import { useState, useEffect, useCallback } from 'react';

export const usePxToVw = () => {
  const [baseWidth, setBaseWidth] = useState(1920);
  const [is4KScreen, setIs4KScreen] = useState(false);

  useEffect(() => {
    const updateBaseWidth = () => {
      const screenWidth = window.innerWidth;     
      // Decide design base:
      if (screenWidth >= 2560) {
        // setBaseWidth(3840); // 4K design base
        setBaseWidth(1920);
      } else {
        setBaseWidth(1920); // Full HD design base
      }

      const is4K = screenWidth >= 2560;
      
      setIs4KScreen(is4K);
    };

    updateBaseWidth();
    window.addEventListener('resize', updateBaseWidth);

    return () => window.removeEventListener('resize', updateBaseWidth);
  }, []);

  const getMaxWidth = useCallback(
    (defaultMaxWidth = '25vw') => {
      return is4KScreen ? '100vw' : defaultMaxWidth;
    },
    [is4KScreen]
  );


  const pxToVw = useCallback(px => `${(px / baseWidth) * 100}vw`, [baseWidth]);

  const pxToPercentage = useCallback(px => {
    if (!px) return '0%';
    return `${(px / baseWidth) * 100}%`;
  });

  return { pxToVw, getMaxWidth, pxToPercentage };
};
